import React from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';


import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import modelsComplete from '../../db/models.json';


import 'react-medium-image-zoom/dist/styles.css'
import 'react-slideshow-image/dist/styles.css'


const buttonStyle = {
    width: "50px",
    height: "160px",
    background: 'none',
    border: '0px',
    marginLeft: "10px",
    marginRight: "20px"
};

const spanStyle = {
 	padding: '20px',
  	color: '#000000'
}

const divStyle = {
  	display: 'flex',
  	alignItems: 'center',
  	justifyContent: 'center',
 	backgroundSize: 'cover',
  	height: '100vH'
}

const divStyleSmall = {
  	display: 'flex',
  	alignItems: 'center',
  	justifyContent: 'center',
 	backgroundSize: 'cover',
  	height: '50vH'
}

const properties = {
    prevArrow: <button style={{ ...buttonStyle }}><ArrowBackIosIcon sx={{width: "3em", height: "3em", fill: "#fff", zIndex: 3000}}/></button>,
    nextArrow: <button style={{ ...buttonStyle }}><ArrowForwardIosIcon sx={{width: "3em", height: "3em", fill: "#fff", zIndex: 3000}}/></button>
}




export default function Header(props) {
  	let navigate = useNavigate(); 

	const { t, i18n } = useTranslation("",{lng: props.language});

	
	
  	const [page, setPage] = React.useState("home");
	const [open, setOpen] = React.useState(false);

	
	const callUrl = (url) => {
		navigate(url);
	};

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};
	

  	const change = (which) => {
		setPage(which);
	}
	
	
	  const [anchorEl, setAnchorEl] = React.useState(null);
	  const openMenu = Boolean(anchorEl);
	  const handleClickMenu = (event) => {
	    setAnchorEl(event.currentTarget);
	  };
	  const handleCloseMenu = () => {
	    setAnchorEl(null);
	  };	

	  const handleClickFilter = () => {
	    setAnchorEl(null);
	  };
	
	
	  const handleClickOpen = () => {
	    setAnchorEl(null);
	    setOpen(true);
	  };
	
	  const handleClose = () => {
	    setOpen(false);
	  };
	
	
	
	
  	return (<>
				<AppBar position="fixed">
		        	<Toolbar>
		      			<IconButton
					        aria-controls={openMenu ? 'basic-menu' : undefined}
					        aria-haspopup="true"
					        aria-expanded={openMenu ? 'true' : undefined}
					        onClick={handleClickMenu}					          
				            size="large"
				            edge="start"
				            color="inherit"
				            aria-label="open drawer"
				            sx={{ mr: 2 }}
				          >
			          		<MenuIcon />
			          	</IconButton>
		          	
					<Menu
				        id="basic-menu"
				        anchorEl={anchorEl}
				        open={openMenu}
				        onClose={handleCloseMenu}
				        MenuListProps={{
				          'aria-labelledby': 'basic-button',
				        }}
				      >
						{modelsComplete.cars.map((model) => (
								<>
									{model.onlinestatus == "online" && model.compareable == "true" ? (
							        	<MenuItem onClick={e => callUrl("/model/" + model.url + "/")}>{model.producerLabel} {model.label}</MenuItem>
									):(<></>)
									}
					        	</>											
						))}		
				      
			    	</Menu>		
							<a onClick={e => callUrl("/")}>
								<img src={"/assets/logo-vanconcept.png"} width="80" style={{marginLeft: "0px"}}/>
							</a>			    				          
				</Toolbar>
		      </AppBar>		
			</>
	  )
}